import React, { useEffect } from 'react';
import { StringParam, useQueryParams } from 'use-query-params';
import { BulkRosterScreen } from './bulk-roster/BulkRosterScreen';
import { IndividualRosterScreen } from './IndividualRosterScreen';
import { CalendarRosterScreen } from './calendar-roster/CalendarRosterScreen';
import { useSession } from '../../../global/auth/useSession';

export const RostersScreen = () => {
  const { user } = useSession();
  const [query, setQuery] = useQueryParams({
    view: StringParam,
    sortVolsRowBy: StringParam,
  });

  useEffect(() => {
    const rosterView = user?.userPreference?.rosterView;
    if (!query.view && rosterView) {
      setQuery({ view: rosterView });
    }
    if (!query.sortVolsRowBy) {
      setQuery({ sortVolsRowBy: 'rostered' });
    }
  }, []);

  const renderView = () => {
    switch (query.view) {
      case 'bulk':
        return <BulkRosterScreen />;
      case 'calendar':
        return <CalendarRosterScreen />;
      default:
        return <IndividualRosterScreen />;
    }
  };

  return <React.Fragment>{renderView()}</React.Fragment>;
};
